import axios from "axios"
import * as env from "../constants/env"


/* GET CHATS */
export const chats = () => {
    const uri = `${env.gamepoint}admin/support/chats`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* GET MESSAGES */
export const messages = (data) => {
    const uri = `${env.gamepoint}admin/support/messages`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* SEND MESSAGE */
export const send = (data) => {
    const uri = `${env.gamepoint}admin/support/send`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* GET BADGE */
export const badge = () => {
    const uri = `${env.gamepoint}admin/support/badge`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}